module.exports = __webpack_public_path__ + "img/Result.9b4afaa6.png";